import React, { forwardRef } from 'react';
import classNames from 'classnames';
import './ActionButton.scss';

export default forwardRef(function ActionButton(
  { children, className, disabled, onClick, ...props },
  ref,
) {
  return (
    <div
      role="button"
      ref={ref}
      onClick={!disabled ? onClick : undefined}
      className={classNames('action-button', { disabled }, className)}
      {...props}
    >
      {children}
    </div>
  );
});
